"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Growth = function Growth(_ref) {
  var borderColor = _ref.borderColor,
      offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, _react.default.createElement("g", {
    fill: offsetColor
  }, _react.default.createElement("circle", {
    cx: "399.6",
    cy: "95.75",
    r: "55.85"
  }), _react.default.createElement("path", {
    d: "M40.56 311.19H8.64l63.84-79.8 63.83 79.8H104.4v151.6H40.56zm127.67-127.67H136.3l63.84-79.8 63.83 79.8h-31.92V462.8h-63.83z"
  })), _react.default.createElement("g", {
    fill: borderColor
  }, _react.default.createElement("path", {
    d: "M399.63 127.67c-35.2 0-63.84-28.64-63.84-63.84S364.43 0 399.62 0s63.84 28.64 63.84 63.83-28.63 63.84-63.83 63.84zm0-111.71c-26.4 0-47.88 21.47-47.88 47.87s21.47 47.88 47.88 47.88c26.4 0 47.87-21.47 47.87-47.88s-21.47-47.87-47.88-47.87z"
  }), _react.default.createElement("path", {
    d: "M503.36 311.19a7.97 7.97 0 01-7.98-7.98V167.56a31.95 31.95 0 00-31.92-31.91H335.79a31.95 31.95 0 00-31.92 31.91v135.65a7.97 7.97 0 11-15.95 0V167.56a47.92 47.92 0 0147.87-47.87h127.67a47.92 47.92 0 0147.87 47.87v135.65a7.97 7.97 0 01-7.97 7.98z"
  }), _react.default.createElement("path", {
    d: "M463.46 510.67H335.79a7.97 7.97 0 01-7.98-7.98v-271.3a7.97 7.97 0 1115.96 0v263.32h111.71V231.4a7.97 7.97 0 1115.96 0v271.29a7.97 7.97 0 01-7.98 7.98z"
  }), _react.default.createElement("path", {
    d: "M399.63 510.67a7.97 7.97 0 01-7.98-7.98V327.15a7.97 7.97 0 1115.95 0v175.54a7.97 7.97 0 01-7.98 7.98zm-199.48-383a7.97 7.97 0 01-7.98-7.98v-7.98a7.97 7.97 0 1115.96 0v7.98a7.97 7.97 0 01-7.98 7.98zm0-39.9a7.97 7.97 0 01-7.98-7.98v-7.98a7.97 7.97 0 1115.96 0v7.98a7.97 7.97 0 01-7.98 7.98zm0-39.89a7.97 7.97 0 01-7.98-7.98v-7.98a7.97 7.97 0 1115.96 0v7.98a7.97 7.97 0 01-7.98 7.98z"
  }), _react.default.createElement("path", {
    d: "M503.36 512H8.63a7.97 7.97 0 110-15.96h494.71a7.97 7.97 0 110 15.96z"
  }), _react.default.createElement("path", {
    d: "M104.4 510.67H40.56a7.97 7.97 0 01-7.98-7.98V359.06H8.65A7.99 7.99 0 012.4 346.1l63.84-79.8c3.04-3.79 9.43-3.79 12.47 0l63.83 79.8a8 8 0 01-6.24 12.97h-23.94v143.62a7.97 7.97 0 01-7.97 7.98zM48.54 494.7h47.88V351.08a7.97 7.97 0 017.97-7.97h15.32l-47.23-59.04-47.22 59.04h15.31a7.97 7.97 0 017.98 7.97v143.63z"
  }), _react.default.createElement("path", {
    d: "M232.06 510.67h-63.83a7.97 7.97 0 01-7.98-7.98v-271.3h-23.94a7.99 7.99 0 01-6.23-12.96l63.83-79.8c3.04-3.78 9.44-3.78 12.48 0l63.83 79.8a8 8 0 01-6.24 12.97h-23.94v271.29a7.97 7.97 0 01-7.98 7.98zm-55.85-15.96h47.87V223.4a7.97 7.97 0 017.98-7.97h15.31l-47.22-59.04-47.23 59.04h15.32a7.97 7.97 0 017.98 7.98V494.7h-.01zm287.25-15.96H335.79a7.97 7.97 0 110-15.96h127.67a7.97 7.97 0 110 15.96zM72.48 255.33a7.97 7.97 0 01-7.98-7.98v-7.97a7.97 7.97 0 1115.96 0v7.97a7.97 7.97 0 01-7.98 7.98zm0-39.89a7.97 7.97 0 01-7.98-7.98v-7.98a7.97 7.97 0 1115.96 0v7.98a7.97 7.97 0 01-7.98 7.98zm0-39.9a7.97 7.97 0 01-7.98-7.98v-7.98a7.97 7.97 0 1115.96 0v7.98a7.97 7.97 0 01-7.98 7.98z"
  })));
};

Growth.propTypes = {
  borderColor: _propTypes.default.string,
  offsetColor: _propTypes.default.string
};
Growth.defaultProps = {
  borderColor: "#242523",
  offsetColor: "#63DC3E"
};
var _default = Growth;
exports.default = _default;